import { useEffect, useState } from 'react';

type Props = {
    key: string;
    defaultValue?: string;
    isSupportCqh: boolean;
};
export const useCSSProperty = (props: Props) => {
    const { key, defaultValue = '', isSupportCqh } = props;
    const [value, setValue] = useState<string>(defaultValue);
    useEffect(() => {
        if (isSupportCqh && key.indexOf('-cqh') > 0) {
            //support cqh no need to set
        } else if (isSupportCqh && key.indexOf('-cqw') > 0) {
            //support cqw no need to set
        } else if (defaultValue != '') {
            document.documentElement.style.setProperty(key, defaultValue);
        }
    }, []);
    useEffect(() => {
        if (isSupportCqh && key.indexOf('-cqh') > 0) {
            //support cqh no need to set
        } else if (isSupportCqh && key.indexOf('-cqw') > 0) {
            //support cqw no need to set
        } else if (value != '') {
            document.documentElement.style.setProperty(key, value);
        }
    }, [value]);
    return {
        setValue,
    };
};
